import React, { useState, useRef } from "react";
import { AiOutlineCloseCircle } from "react-icons/ai";
import Inputfield from "../InputField/Inputfield";
import Radiofield from "../Radiofield/Radiofield";
import "./addemployee.css";
import axios from "axios";
import { useCookies } from "react-cookie";
import UploadImage from "../upload/UploadImage";
import Multiselectdrpdwn from "../Multiselect/multiselectdrpdwn";

const Addemployee = ({ sendnotice, empselect, params }) => {
  const [gender, setGender] = useState({ male: true, female: false });
  const [level, setLevel] = useState({ staff: true, head: false });
  const [loaderror, setLoaderror] = useState({
    statusid: 0,
    message: "",
  });
  const API = "https://staging.sabrecwa.com/staff";
  const [cookies] = useCookies(["Token"]);
  const [values, setValues] = useState({
    email: "",
    fname: "",
    lname: "",
    phoneno: "",
    country: "",
    region: "",
    design: "",
    depart: "",
    gender: "Male",
    roles: [],
    image_url: "",
    head: {
      is_head: level.head,
      department_id: 0,
    },
    executive_name: "",
    qualifications: "",
    position_held: "",
    brief_about: "",
  });

  // console.log(cookies.Token)

  const handleSubmit = (e) => {
    e.preventDefault();
    // Submit Data
    if (params.id !== undefined || params.id > 0) {
      // console.log("edit command")
      UpdateRequest(params.id);
    } else {
      // console.log("normal open")
      UpdateRequest();
    }
  };

  const UpdateRequest = async (props) => {
    sendnotice({
      action: "load",
      text: "Sending Data...",
    });

    const employeeobj = {
      email: values.email,
      first_name: values.fname,
      last_name: values.lname,
      phone: values.phoneno,
      country_id: values.country,
      region_id: values.region,
      department_id: values.depart,
      designation: values.design,
      gender: values.gender,
      staff_roles: [...values.roles],
      image_url: values.image_url,
      head: {
        is_head: level.head,
        department_id: values.depthead,
      },
      executive_name: values.executive_name,
      qualifications: values.qualifications,
      position_held: values.position_held,
      brief_about: values.brief_about,
    };

    if (
      employeeobj.first_name !== "" &&
      employeeobj.last_name !== "" &&
      employeeobj.email !== "" &&
      employeeobj.phone !== "" &&
      employeeobj.country_id !== "" &&
      employeeobj.region_id !== "" &&
      employeeobj.designation !== "" &&
      employeeobj.gender !== "" &&
      employeeobj.image_url !== "" &&
      employeeobj.department_id !== ""
    ) {
      try {
        var config = {
          method: "POST",
          url: `${API}/hr/create/staff`,
          data: employeeobj,
          headers: {
            Authorization: "Bearer " + cookies.Token,
          },
        };

        console.log(config.data);

        await axios(config).then((response) => {
          console.log(response);
          if (response.data.success === true) {
            sendnotice({
              action: "success",
              text: response.data.message,
            });
          }
        });
      } catch (e) {
        console.log(e.response.data.message);
        // sendnotice({
        //     action: "notload",
        //     text: e.response.data.message
        // })
      }
    } else {
      setLoaderror({
        statusid: 1,
        message: "All Fields Not completely filled",
      });
    }
  };

  const handleEmpFname = (incoming) => {
    setValues({ ...values, fname: incoming });
  };

  const handleEmpLname = (incoming) => {
    setValues({ ...values, lname: incoming });
  };

  const handleEmpId = (incoming) => {
    setValues({ ...values, email: incoming });
  };

  const handleEmpPhone = (incoming) => {
    setValues({ ...values, phoneno: incoming });
  };

  const handleEmpCountry = (incoming) => {
    setValues({ ...values, country: incoming });
  };

  const handleEmpRegion = (incoming) => {
    setValues({ ...values, region: incoming });
  };

  const handleEmpDesign = (incoming) => {
    setValues({ ...values, design: incoming });
  };

  const handleEmpDepart = (incoming) => {
    setValues({ ...values, depart: incoming });
  };

  const handleEmpDpt = (incoming) => {
    setValues({ ...values, depthead: incoming });
  };

  const onChangeText = (e) => {
    const { name } = e.target;
    if (name === "male") {
      setGender({ male: true, female: false });
      setValues({ ...values, gender: "Male" });
      // console.log("male")
    }
    if (name === "female") {
      setGender({ male: false, female: true });
      setValues({ ...values, gender: "Female" });
      // console.log("female")
    }
  };

  const onChangeLevel = (e) => {
    const { name } = e.target;
    if (name === "staff") {
      setLevel({ staff: true, head: false });
    }
    if (name === "head") {
      setLevel({ staff: false, head: true });
    }
  };

  const handleClose = () => {
    sendnotice({
      action: "close",
      text: "",
    });
  };

  const handledirectoryUpdate = (incoming) => {
    setValues({ ...values, image_url: incoming });
  };

  const handleSelectedRole = (incoming) => {
    // console.log(incoming)
    setValues({ ...values, roles: incoming });
  };

  const handleToggleSelection = () => {
    setLoaderror({
      statusid: 0,
      message: "",
    });
  };

  return (
    <div className="overlay-container">
      <div className="overlay-addemployee-container">
        <div className="top-container-apprais-notif">
          <span>ADD NEW EMPLOYEE</span>
          <AiOutlineCloseCircle id="closeIcon-notifc" onClick={handleClose} />
        </div>

        <form
          onSubmit={handleSubmit}
          className="top-addemployee-container-body"
        >
          <div className="add_emp_body_row">
            <UploadImage
              onfocus={handleToggleSelection}
              directory={handledirectoryUpdate}
            />
          </div>

          {loaderror.statusid === 1 ? (
            <div className="errorpopup">
              <span>{loaderror.message}</span>
            </div>
          ) : (
            ""
          )}

          <div className="addemployee-addrow">
            <div
              onFocus={handleToggleSelection}
              className="addemployee-addrow-cola"
            >
              <Inputfield
                personname={handleEmpFname}
                fieldlabel="Firstname :"
                placehold="Firstname here"
                typeid="text"
              />
            </div>

            <div
              onFocus={handleToggleSelection}
              className="addemployee-addrow-cola"
            >
              <Inputfield
                personname={handleEmpLname}
                fieldlabel="Lastname :"
                placehold="Lastname here"
                typeid="text"
              />
            </div>
          </div>

          <div className="addemployee-addrow">
            <div
              onFocus={handleToggleSelection}
              className="addemployee-addrow-cola"
            >
              <Inputfield
                personname={handleEmpId}
                fieldlabel="Email :"
                placehold="Email"
                typeid="email"
              />
            </div>

            <div
              onFocus={handleToggleSelection}
              className="addemployee-addrow-cola"
            >
              <Inputfield
                personname={handleEmpPhone}
                fieldlabel="Phone Nos :"
                placehold="+234..."
                typeid="number"
              />
            </div>
          </div>

          <div className="addemployee-addrow">
            <div
              onFocus={handleToggleSelection}
              className="addemployee-addrow-cola"
            >
              <Inputfield
                RegionJson={empselect.allRegions}
                fieldlabel="Region :"
                unithead={handleEmpRegion}
                placehold="Select Region..."
                typeid="regiondropdwn"
              />
            </div>

            <div
              onFocus={handleToggleSelection}
              className="addemployee-addrow-cola"
            >
              <Inputfield
                CountryJson={empselect.allCountries}
                fieldlabel="Country :"
                unithead={handleEmpCountry}
                placehold="Select Country..."
                typeid="countrydropdwn"
              />
            </div>
          </div>

          <div className="addemployee-addrow">
            <div
              onFocus={handleToggleSelection}
              className="addemployee-addrow-cola"
            >
              <Inputfield
                DesignJson={empselect.allDesignations}
                fieldlabel="Designation :"
                unithead={handleEmpDesign}
                placehold="Select Des..."
                typeid="descdropdwn"
              />
            </div>

            <div
              onFocus={handleToggleSelection}
              className="addemployee-addrow-cola"
            >
              <Inputfield
                DepartmentJson={empselect.allDepartments}
                fieldlabel="Department :"
                unithead={handleEmpDepart}
                placehold="Select Dep..."
                typeid="deptdropdwn"
              />
            </div>
          </div>

          <div className="addemployee-addrow">
            <div
              onFocus={handleToggleSelection}
              className="addemployee-addrow-cola"
            >
              <Multiselectdrpdwn
                roleselected={handleSelectedRole}
                RoleJson={empselect.allDesignations}
                fieldlabel="Role"
              />
            </div>
          </div>

          <div className="addemployee-addrow">
            <div
              onFocus={handleToggleSelection}
              className="addemployee-addrow-cola-cont"
            >
              <span>Gender:</span>
              <div className="addemployee-addrow-cola">
                <Radiofield
                  name="male"
                  id="male"
                  value="Male"
                  onChange={onChangeText}
                  checked={gender.male}
                  text="Male"
                />
                <Radiofield
                  name="female"
                  id="female"
                  value="Female"
                  onChange={onChangeText}
                  checked={gender.female}
                  text="Female"
                />
              </div>
            </div>

            <div
              onFocus={handleToggleSelection}
              className="addemployee-addrow-cola-cont"
            >
              <span>Clerance Level:</span>
              <div className="addemployee-addrow-cola">
                <Radiofield
                  name="staff"
                  id="staff"
                  value="Staff"
                  onChange={onChangeLevel}
                  checked={level.staff}
                  text="Staff"
                />
                <Radiofield
                  name="head"
                  id="head"
                  value="Head"
                  onChange={onChangeLevel}
                  checked={level.head}
                  text="Head"
                />
              </div>
            </div>
          </div>

          {level.head && (
            <div className="addemployee-addrow">
              <div
                onFocus={handleToggleSelection}
                className="addemployee-addrow-cola"
              >
                <Inputfield
                  DepartmentJson={empselect.allDepartments}
                  headofunit={handleEmpDpt}
                  unithead={() => {}}
                  fieldlabel="Choose Department"
                  placehold="Select Depart..."
                  typeid="deptheaddropdwn"
                />
              </div>
            </div>
          )}

          <div className="top-addemployee-submit-row">
            <button id="broadcast-buttn" type="submit">
              SUBMIT
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Addemployee;
